import React from 'react';

interface FieldProps {
  id: string;
  label: string;
  /** Se muestra como `· opcional` al lado del label. La especificación prohíbe asteriscos. */
  optional?: boolean;
  error?: string;
  help?: string;
  /** Badge ✓ dentro del campo. */
  isValid?: boolean;
  children: React.ReactNode;
}

export const Field: React.FC<FieldProps> = ({
  id,
  label,
  optional,
  error,
  help,
  isValid,
  children,
}) => (
  <div className="bk-field">
    <label className="bk-label" htmlFor={id}>
      {label}
      {optional && <span className="bk-label__optional"> · opcional</span>}
    </label>
    <div className="bk-input-wrap">
      {children}
      {isValid && !error && (
        <span className="bk-check" aria-hidden="true">
          &#10003;
        </span>
      )}
    </div>
    {error ? (
      <span className="bk-error">{error}</span>
    ) : help ? (
      <span className="bk-help">{help}</span>
    ) : null}
  </div>
);

/** Sobre (email). Lineal, del mismo peso de trazo que el candado. */
export const MailIcon: React.FC = () => (
  <svg className="bk-icon" width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
    <rect x="2.5" y="4.5" width="15" height="11" rx="2" />
    <path d="M3 6l7 5 7-5" />
  </svg>
);

/** Pin de mapa, para las opciones del buscador de direcciones. */
export const PinIcon: React.FC = () => (
  <svg className="bk-icon" width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
    <path d="M10 17.5s5.5-5 5.5-9a5.5 5.5 0 1 0-11 0c0 4 5.5 9 5.5 9Z" />
    <circle cx="10" cy="8.5" r="2" />
  </svg>
);

/** Candado (contraseña). */
export const LockIcon: React.FC = () => (
  <svg className="bk-icon" width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
    <rect x="4.5" y="8.5" width="11" height="8" rx="2" />
    <path d="M7 8.5V6.5a3 3 0 0 1 6 0v2" />
  </svg>
);

/**
 * Mostrar u ocultar la contraseña.
 *
 * Va como ícono y no como la palabra "Mostrar": en el par de dos columnas el texto se
 * comía unos 55px y el valor del campo terminaba pegado al botón. El estado accesible lo
 * dan el `aria-label` y el `aria-pressed` del botón, no el dibujo.
 */
export const EyeIcon: React.FC<{ crossed?: boolean }> = ({ crossed }) => (
  <svg className="bk-icon" width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
    <path d="M1.8 10S4.6 5 10 5s8.2 5 8.2 5-2.8 5-8.2 5-8.2-5-8.2-5Z" />
    <circle cx="10" cy="10" r="2.4" />
    {crossed && <path d="M3.5 16.5 16.5 3.5" />}
  </svg>
);
